import { EditNote } from '@mui/icons-material';
import type { ButtonProps } from '@mui/material/Button';
import Button from '@mui/material/Button';
import { FC } from 'react';
import { StyledSkeleton } from 'src/components/styled/StyledSkeleton';
import { useDrawerState } from 'src/hooks/useDrawerState';
import { recordAction } from 'src/infrastructure/telemetry';

interface Props extends ButtonProps {
    loading?: boolean;
    disabled?: boolean;
    onSave?: () => unknown;
}

const BulkEditButton: FC<Props> = ({ loading, disabled, ...props }) => {
    const { bulkEditDrawerOpen, setBulkEditDrawerOpen } = useDrawerState();

    const openBulkEditDrawer = () => {
        setBulkEditDrawerOpen(!bulkEditDrawerOpen);
        recordAction('bulk-edit', {
            action: 'open',
        });
    };
    return (
        <>
            {!loading && (
                <Button
                    disabled={disabled}
                    color="info"
                    variant="contained"
                    startIcon={<EditNote />}
                    onClick={openBulkEditDrawer}
                    loading={loading}
                    loadingPosition="start"
                    {...props}
                >
                    Bulk Edit
                </Button>
            )}
            {loading && <StyledSkeleton variant="rectangular" width={100} height={30} />}
        </>
    );
};

export default BulkEditButton;
